import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageEventServiceService } from 'src/app/shared/services/local-storage-event-service.service';


interface ProductMeta {
  id?: string;
  status?: string;
  dibd?: string | null; // DIBD
  ibd?: string | null; // IBD
  safetyTitle?: string;
  safetyStrategyLink?: string;
  producttype?: string;
   productName?: string;
}

@Component({
    selector: 'app-jsip-product-info-bar',
    templateUrl: './jsip-product-info-bar.component.html',
    styleUrls: ['./jsip-product-info-bar.component.scss'],
    standalone: false
})
export class JsipProductInfoBarComponent implements OnInit {
@Output() productNavToggle = new EventEmitter<any>();
  productMeta?: ProductMeta;
  selectedProduct: any = null; 
  constructor(private storeEvents:LocalStorageEventServiceService,private router: Router) { }

  ngOnInit(): void {
      this.storeEvents.selectedProduct$.subscribe(v => {
        if(v){
           this.productMeta = v; // ✅ event triggered here
            this.selectedProduct= this.productMeta.productName
            this.productNavToggle.emit(this.selectedProduct)
        }else{
          this.productMeta =null; // ✅ event triggered here
            this.selectedProduct=null;
             this.productNavToggle.emit(this.selectedProduct)
        }
   
  });
  }

    computeInitials(fullName?: string): string {
    const safe = (fullName || "").trim();
    const parts = safe.split(/\s+/).filter((p) => p);
    if (parts.length === 0) return "";
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  openSafetyStrategy(){
    this.storeEvents.setSubMenuCurrentSection('Product Info')
    this.router.navigate(
      ['/user/Menubar/jsip-productstrategy'],
      {
        state: {
          productMetaData:this.productMeta
        }
      }
    );
  }
}
